import styled from "styled-components";
import { theme } from "@themes";

export const InputFile = styled.input`
  display: none;
`;

export const ButtonFile = styled.label`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  display: inline-block;
  padding: 6px 12px 6px 12px;
  cursor: pointer;
  background: ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  margin-top: 10px;
`;

export const UpLoadFileContainer = styled.div`
  ${({ withStyle }) =>
    withStyle &&
    `
  padding: 10px;
  width: 100% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
`}
`;

export const NameFile = styled.span`
  padding: 1rem;
  font-weight: bold;
`;

export const ButtonDelete = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-sizing: border-box;
  border-radius: 3px;
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.font.primary};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  margin-left: 10px;
`;
